<template>
    <div>
        <minhead :headtitle="headtitle"></minhead>
        <div class="areacontent">
            <div class="between-line">
                <el-form>
                    <el-row type="flex">
                        <el-col :span="8">
                            <el-form-item label="领购年份:">
                                <el-select v-model="year" style="width: 140px;">
                                    <el-option label="全部" value></el-option>
                                    <el-option
                                        v-for="item in yearOpt"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" style="margin-left:40px">
                            <el-form-item label="领购月份:">
                                <el-select v-model="month" style="width: 140px;">
                                    <el-option label="全部" value></el-option>
                                    <el-option
                                        v-for="item in monthOpt"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" style="margin-left:40px">
                            <el-form-item label="发票种类:" @change="getDistributeInventoryList">
                                <el-select v-model="faplxdm" style="width: 140px;">
                                    <el-option label="全部" value></el-option>
                                    <el-option label="电子普票" value="026"></el-option>
                                    <el-option label="电子专票" value="028"></el-option>
                                    <el-option label="纸质普票" value="007"></el-option>
                                    <el-option label="纸质专票" value="004"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="Centerupdown" style="float:right;margin:10px">
                    <el-button type="primary" @click="getDistributeInventoryList" plain>
                        查询
                        <i class="el-icon-refresh el-icon--right"></i>
                    </el-button>
                    <el-button type="primary" @click="excelExport" plain>
                        导出
                        <i class="el-icon-upload2 el-icon--right"></i>
                    </el-button>
                </div>
            </div>
        </div>
        <div class="areatable">
            <div class="tableh">
                <el-table
                    :data="tableData"
                    border
                    style="width: 100%"
                    :height="tableHeight"
                    ref="multipleTable"
                >
                    <el-table-column prop="faplxdm" label="发票种类" align="center">
                        <template slot-scope="scope">
                            <p v-if="scope.row.faplxdm == '026'">电子普票</p>
                            <p v-if="scope.row.faplxdm == '028'">电子专票</p>
                            <p v-if="scope.row.faplxdm == '007'">纸质普票</p>
                            <p v-if="scope.row.faplxdm == '004'">纸质专票</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="fapdm" label="发票代码" align="center"></el-table-column>
                    <el-table-column prop="zuidkpje" label="开票限额" align="center"></el-table-column>
                    <el-table-column prop="qishm" label="起始号码" align="center"></el-table-column>
                    <el-table-column prop="zhongzhm" label="终止号码" align="center"></el-table-column>
                    <el-table-column prop="fapfs" label="发票份数" align="center"></el-table-column>
                    <el-table-column prop="shengyfs" label="剩余份数" align="center"></el-table-column>
                    <el-table-column prop="createTime" label="领购日期" align="center"></el-table-column>
                </el-table>
            </div>
            <div class="buttompage">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 100, 500]"
                    :page-size="pagenum"
                    :key="elementui_page_component_key"
                    :current-page="currentpage"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalcount"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            page: 1,
            pagenum: 10,
            totalcount: 10,
            tableData: [],
            headtitle: ['库存管理', '发票库存查询'],
            tableHeight: '',
            currentpage: 1,
            elementui_page_component_key: '',
            faplxdm: '',
            year: '',
            month: '',
            yearOpt: (function() {
                let year = [];
                let date = new Date();
                let current_year = date.getFullYear();
                for (let i = 0; i < 10; i++) {
                    let y = current_year - i;
                    year.push({
                        value: y,
                        label: y + '年'
                    });
                }
                return year;
            })(),
            monthOpt: (function() {
                let month = [];
                for (let i = 1; i < 13; i++) {
                    month.push({
                        value: i,
                        label: i + '月'
                    });
                }
                return month;
            })()
        };
    },
    created() {
        this.getDistributeInventoryList();
    },
    mounted() {
        this.repairtable();
    },
    methods: {
        repairtable(){
            this.$nextTick(() => {
                this.tableHeight = this.diagheightzhengshutiankai();
                setTimeout(() => {
                    this.$refs.multipleTable.doLayout();
                }, 300);
                window.onresize = () => {
                    this.tableHeight = this.diagheightzhengshutiankai();
                    setTimeout(() => {
                        this.$refs.multipleTable.doLayout();
                    }, 300);
                };
            });
        },
        forserch() {
             this.currentpage = 1;
             this.elementui_page_component_key++;
             this.page = 1;
             this.getDistributeInventoryList();
         },
        handleSizeChange(val) {
            this.pagenum = val;
            this.getDistributeInventoryList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getDistributeInventoryList();
        },
        getDistributeInventoryList() {
            let params = {
                page: this.page,
                limit: this.pagenum,
                sort: 'desc',
                order: 'edd.createTime',
                search: {}
            };
            if (this.faplxdm && this.faplxdm != '') {
                params.search.faplxdm = this.faplxdm;
            }
            if (this.year && this.year != '') {
                params.search.year = this.year;
            }
            if (this.month && this.month != '') {
                params.search.month = this.month;
            }
            this.$https.fetchPost('/inventory/getDistributeInventoryList', params).then(res => {
                this.tableData = res.data.data;
                this.totalcount = res.data.count;
                // console.log('****==>' + JSON.stringify(res.data.data));
            });
        },
        excelExport() {
            let param = {};
            if (this.faplxdm && this.faplxdm != '') {
                params.faplxdm = this.faplxdm;
            }
            if (this.year && this.year != '') {
                params.year = Num(this.year);
            }
            if (this.month && this.month != '') {
                params.month = Num(this.month);
            }
            this.$https.fetchdowload('/inventory/exportDistributeInventoryList', param).then(res => {
                const content = res.data;
                const blob = new Blob([content]);
                var date = new Date().getFullYear() + '' + (new Date().getMonth() + 1) + '' + new Date().getDate();
                var companyName = JSON.parse(localStorage.getItem('useropj')).currCompany.name;
                const fileName = companyName + date + '发票已分发库存' + '.xls';
                if ('download' in document.createElement('a')) {
                    // 非IE下载
                    const elink = document.createElement('a');
                    elink.download = fileName;
                    elink.style.display = 'none';
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href); // 释放URL 对象
                    document.body.removeChild(elink);
                } else {
                    // IE10+下载
                    navigator.msSaveBlob(blob, fileName);
                }
            });
        }
    }
};
</script>

<style scoped="scoped" lang="less">
/deep/.el-dialog__body {
    padding: 0;
}
/deep/.el-table--small td {
    padding: 4px 0;
}
/deep/.el-table__body-wrapper {
    min-height: 160px;
}

.topspan > span {
    font-size: 17px;
    color: #0080ff;
}
.areatable {
    margin-top: 27px;
}
.areacontent {
    margin-left: 21px;
}
</style>
